export const PLATFORM_CAPABILITIES = [
  'anonymous_rides',
  'fixture_launch',
  'canvas_capture',
  'cloud_drafts',
  'publishing',
  'catalog_hover_upload',
  'public_catalog',
  'read_only_shares',
  'remixing',
  'social_writes',
  'camera',
  'microphone',
  'referrals',
  'credits',
  'iap',
  'rewarded_ads',
] as const;

export type PlatformCapabilityId = (typeof PLATFORM_CAPABILITIES)[number];
export type PlatformPhaseGate = 'phase_1' | 'phase_4' | 'phase_6' | 'phase_7' | 'phase_8';

export interface PlatformCapabilityState {
  id: PlatformCapabilityId;
  availability: 'available' | 'unavailable';
  phaseGate: PlatformPhaseGate;
  reason: string;
}

export type PlatformErrorCode =
  | 'capability_unavailable'
  | 'invalid_request'
  | 'not_found'
  | 'unauthenticated'
  | 'forbidden'
  | 'conflict'
  | 'validation_failed'
  | 'timeout'
  | 'platform_error';

export type PlatformResult<T> =
  | { ok: true; value: T }
  | {
      ok: false;
      error: {
        code: PlatformErrorCode;
        message: string;
        recoverable: boolean;
        capability?: PlatformCapabilityId;
        retryable: boolean;
        details?: Readonly<Record<string, unknown>>;
      };
    };

export function unavailable<T>(capability: PlatformCapabilityState): PlatformResult<T> {
  return {
    ok: false,
    error: {
      code: 'capability_unavailable',
      message: `${capability.reason} This feature unlocks after the ${capability.phaseGate.replace('_', ' ')} platform gate.`,
      recoverable: true,
      capability: capability.id,
      retryable: false,
    },
  };
}
